module.exports = __webpack_public_path__ + "img/prj10.a4d503f2.png";